import React, { useState } from "react";
import { BankOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useIntl } from "react-intl";
import { useRouteMatch } from "react-router-dom";
import { useQuery } from "@apollo/client";
import IntlMessages from "../../../util/IntlMessages";
import { ADMIN_ROUTE_PREFIX } from "../../../constants/App";
import { GQL_TAX_ACCOUNT } from "../../../apollo/query/tax-account";
import { GQL_DOSSIER } from "../../../apollo/query/dossier";
import { GQL_TARI_BILL_COMUNE } from "../../../apollo/query/tari";
import MEFDrawer from "./drawer";

const MEFToolbarIcon = () => {
   const intl = useIntl();
   const [visible, setVisible] = useState(false);

   //Se siamo dentro un'utenza, una pratica o una bolletta TARI mostra il comune dell'utenza
   const taxAccountMatch = useRouteMatch(
      `/${ADMIN_ROUTE_PREFIX}/customers/:customerId/tax-account/update/:id`
   );
   const dossierMatch = useRouteMatch(
      `/${ADMIN_ROUTE_PREFIX}/workarea/dossier/update/:id`
   );
   const tariBillMatch = useRouteMatch([
      `/${ADMIN_ROUTE_PREFIX}/workarea/tari/view/:id`,
      `/${ADMIN_ROUTE_PREFIX}/workarea/tari/update/:id`,
   ]);
   const taxAccountId = taxAccountMatch?.params?.id;
   const dossierId = dossierMatch?.params?.id;
   const tariBillId = tariBillMatch?.params?.id;

   const { data: taxAccountData } = useQuery(GQL_TAX_ACCOUNT, {
      variables: { id: taxAccountId },
      skip: !taxAccountId,
   });
   const { data: dossierData } = useQuery(GQL_DOSSIER, {
      variables: { id: dossierId },
      skip: !dossierId,
   });
   const { data: tariBillData } = useQuery(GQL_TARI_BILL_COMUNE, {
      variables: { id: tariBillId },
      skip: !tariBillId,
   });

   let comune = null;
   if (taxAccountId) {
      comune = taxAccountData?.taxAccount?.comune ?? null;
   } else if (dossierId) {
      comune = dossierData?.dossier?.taxAccount?.comune ?? null;
   } else if (tariBillId) {
      comune = tariBillData?.tariBill?.tax_account?.comune ?? null;
   }

   const label = (
      <>
         <IntlMessages id="common.osservatorio-tari" />
         {comune && ` (${comune.description})`}
      </>
   );

   return (
      <>
         <Tooltip title={intl.formatMessage({ id: "common.osservatorio-tari" })}>
            <div
               style={{
                  color: "white",
                  backgroundColor: "orange",
                  padding: "6px 10px",
                  borderRadius: 20,
               }}
               className="gx-mt-3 gx-pointer"
               onClick={() => setVisible(true)}
            >
               <BankOutlined className="gx-mr-1" />
               {label}
            </div>
         </Tooltip>
         <MEFDrawer
            visible={visible}
            onClose={() => setVisible(false)}
            comune={comune}
         />
      </>
   );
};

export default MEFToolbarIcon;
